// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c15ed13a","455":"93568e8f","977":"ef67daff"}[chunkId] + ".chunk.js";
};